import { render, staticRenderFns } from "./UploadSource.vue?vue&type=template&id=136d7dec&"
import script from "./UploadSource.vue?vue&type=script&lang=js&"
export * from "./UploadSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports